import { Table } from '@tanstack/react-table';

type Props<TData> = {
  table: Table<TData>;
  columnWidths: Record<string, string>;
};

export const ColGroup = <TData,>({ table, columnWidths }: Props<TData>) => (
  <colgroup>
    {table.getVisibleLeafColumns().map((column) => (
      <col key={column.id} style={{ width: columnWidths[column.id] }} />
    ))}
  </colgroup>
);
